module.exports = __webpack_public_path__ + "media/dashboard_application/img/8returns_favicon-e3899217b84ea0c55a18f2721dbcc6a0.png";